export default __webpack_public_path__ + "static/media/line.9bc5f247.svg";